/**
 * V2 admin confirm dialog — native <dialog> replacement for V1's shared
 * delete modal (admin-delete.js). Promise-based so callers read like
 * `if (await confirmDialog(...))`. The destructive path can demand the
 * V1 safety phrase ("CONFIRM DELETE") before the button arms.
 */
import { escapeHtml } from '../../../assets/js/utils.js';

const CONFIRM_PHRASE = 'CONFIRM DELETE';

export function confirmDialog({
  title = 'Are you sure?',
  message = '',
  confirmLabel = 'Delete',
  requirePhrase = false,
} = {}) {
  return new Promise((resolve) => {
    const dialog = document.createElement('dialog');
    dialog.className = 'v2-auth-dialog admin-confirm';
    dialog.innerHTML = `
      <h2 class="v2-dialog-title">${escapeHtml(title)}</h2>
      <p class="admin-confirm-message">${escapeHtml(message)}</p>
      ${requirePhrase ? `
        <label class="admin-confirm-phrase">Type <strong>${CONFIRM_PHRASE}</strong> to proceed:
          <input type="text" data-confirm-input autocomplete="off" spellcheck="false">
        </label>` : ''}
      <div class="admin-confirm-actions">
        <button type="button" class="admin-btn" data-confirm-cancel>Cancel</button>
        <button type="button" class="admin-btn admin-btn-danger" data-confirm-go
          ${requirePhrase ? 'disabled' : ''}>${escapeHtml(confirmLabel)}</button>
      </div>`;
    document.body.appendChild(dialog);

    const goBtn = dialog.querySelector('[data-confirm-go]');
    const input = dialog.querySelector('[data-confirm-input]');

    function close(result) {
      dialog.close();
      dialog.remove();
      resolve(result);
    }

    if (input) {
      input.addEventListener('input', () => {
        goBtn.disabled = input.value.trim().toUpperCase() !== CONFIRM_PHRASE;
      });
    }
    dialog.querySelector('[data-confirm-cancel]').addEventListener('click', () => close(false));
    goBtn.addEventListener('click', () => close(true));
    dialog.addEventListener('cancel', (e) => { e.preventDefault(); close(false); });
    dialog.addEventListener('click', (e) => { if (e.target === dialog) close(false); });

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    if (input) setTimeout(() => input.focus(), 50);
  });
}
